module.exports = __webpack_public_path__ + "img/popup-success-1.9bcdbdce.png";